// global-strings.js

"use strict";

window.FILE_UPLOAD_STR = {
  upload_file_message: "העלאת תמונה",
  upload_file_type_error: "לא ניתן להעלות קובץ מסוג",
  upload_file_empty: "חובה להעלות תמונה",
};

window.ICONS_STR = {
  currency: "₪",
};

window.GLOBAL_STR = {
  block: "חסימה",
  visit_a_business: "לבקר בעסק",
  back_to_home_page: "חזרה לעמוד הבית",
  have_to_login: "חובה להתחבר קודם",
  set_business_as_new: "חדש",
  edit: "עריכה",
  navigator_to_status: "מעבר אוטומטי לסטטוס הזמנה מתבצע בעוד",
  seconds: "שניות",
  empty_data: "אין מידע זמין להצגה",
  empty_cart: "אין מוצרים בסל הקניות שלכם",
  enter_verification_code: "הכניסו קוד האימות שקיבלתם",
  are_you_sure: "האם אתה בטוח ?",
  user_not_found: "משתמש לא קיים",
  business_closed: "העסק סגור כעת",
  navigate_to_crm: "מעבר לממשק ניהול",
  restart_installation_again: "התחילו תהליך התקנה חדש",
  business_time_work: "שעות פעילות",
  publish_in_index: "מפורסם באינדקס",
  not_publish: "לא מפורסם",
  published: "מפורסם",
  title: "כותרת",
  description: "תיאור",
  full_name: "שם מלא",
  first_name: "שם מלא",
  last_name: "שם מלא",
  cancele: "ביטול",
  type: "סוג",
  num: "מספר",
  num_short: "מס׳",
  category: "קטגוריה",
  remove: "מחיקה",
  price: "מחיר",
  congratulations_you_win: "ברכות זכיתם ב",
  sale_price: "מחיר מבצע",
  status: "סטטוס",
  display_in_sale: "להציג במבצעים",
  starting_from: "החל מ",
  no_such_folder_selected: "לא בחרתם תיקיה להוספה",
  recommended: "מומלץ",
  priority: "עדיפות",
  nickname: "כינוי",
  submit_order: "אישור הזמנה",
  submit: "אישור",
  next: "הבא",
  prev: "הקודם",
  Order_Type: "סוג משלוח",
  website: "אתר ToBe",
  app: "אפליקצית ToBe",
  update_product: "עדכון מוצר",
  add_new_product: "הוספת מוצר חדש",
  no_price_set: "לא הוגדר מחיר",
  coiurer: "שליח",
  client: "לקוח",
  try_again: "נסו שוב",
  hello: "שלום",
  continue_reg: "אתם רוצים להמשיך בתהליך",
  register_success: "תהליך הרשמה הסתיים בהצלחה אנו מעבירים אתכם",
  signin_success: "תהליך כניסה בוצע בהצלחה אנו מעבירים אתכם",
};

window.CLIENTS_STR = {
  clients: "לקוחות",
  client: "לקוח",
  client_name: "שם לקוח",
};

window.ORDERS_STR = {
  already_have_sale: "בחרתם כבר מבצע,אין כפל מבצעים",
  order_price_is_lower_than_the_minimum_price_for_delivery: "מחיר הזמנה נמוך מהמחיר המינימלי לקבלת משלוח",
  order_id: "מס׳ הזמנה",
  order: "הזמנה",
  client: "לקוח",
  summary: "סיכום",
  pay_now: "תשלום",
  order_price: "סכום הזמנה",
  price_to_pay: "סכום לתשלום",
  place_order: "בצע הזמנה",
  payment_method: "שיטת תשלום",
  cash: "מזומן",
  credit: "אשראי",
  whay_to_receved_order: "אופן קבלת הזמנה",
  approval_number: "מס` אישור מחברת האשראי",
  delivery_pick_up_time: "זמן איסוף משלוח",
  delivery_to_address: "משלוח לכתובת",
  shipping: "משלוח",
  shipping_price: "מחיר משלוח",
  pickUp: "איסוף עצמי",
  takeaway: "איסוף עצמי",
  sitting: "ישיבה",
  request_approved: "הבקשה מאושרת",
  approved: "מאושר",
  canceled: "מבוטל",
  cancele: "ביטול",
  not_yet_addressed: "טרם טופל",
  client_id_invalid: "מספר ת.ז לא תקין",
  cvv_invalid: "קוד אבטחה לא תקין",
  location_not_selected: "לא הגדרתם מיקום למשלוח",
  invalid_location: "ניתן לבחור מיקום רק באזורי החלוקה שלנו !",
  invalid_user_location: "הכתובת שלכם לא באזור החלוקה של העסק !",
  not_selected: "לא נבחר",
  to_select: "לבחירה",
  min_select: "מינימום בחירה",
  max_select: "מקסימום בחירה",
  max_free: "מקסימום בחינם",
  price: "מחיר",
  min: "מינימום",
  max: "מקסימום",
  free: "תוספות בחינם",
  props_price: "מחיר תוספות",
  sale_price: "מחיר מבצע",
  total_price: "מחיר סופי",
  prop_not_selected: "חובה לבחור את המאפיין קודם",
  item_not_selected: "חובה לבחור את המוצר קודם",
  props_cat: "מרכיבי המנה",
  pickUp_not_selected: "לא הגדרתם שעת איסוף",
  updateAdress_requierd: "חובה לעדכן את הכתובת שלכם לפני",
  area: "אזור",
  send_code: "שלח קוד",
  lower_pick_time: "שעה שבחרתם נמוכנה מהשעה שעכשיו",
  invalid_pick_time: "חובה לבחור שעה בטווח יום העבודה",
  to_pay: "לתשלום",
  cant_move_without_items: "לא ניתן להמשיך בתהליך ללא מוצרים",
  delivery_method: "שיטת מסירה",
};

window.PIZZA_SCECTIONS_STR = {
  part: "חלק",
  full: "על הכל",
  first_half: "חצי א",
  _2nd_half: "חצי ב",
  _1st_qur: "רבע 1",
  _2st_qur: "רבע 2",
  _3rd_qur: "רבע 3",
  _4th_qur: "רבע 4",
};

window.ADDRESS_STR = {
  address: "כתובת",
  street: "רחוב",
  street_name: "שם רחוב",
  Building_no: "מס׳ בניין",
  empty_addresss: "הכתובת שלכם לא שמורה במאגר הנתונים",
  selected_only_from_area: "ניתן לבחור רק באזורים המסומנים במפה",
  invalid_user_location: "הכתובת שלכם לא באזור החלוקה של העסק !",
};

window.PRODUCTS_STR = {
  products: "מוצרים",
  product: "מוצר",
  empty_data: "אין נתונים להצגה",
  product_add: "המוצר נוסף בהצלחה",
  porduct_deleted: "המוצר נמחק בהצלחה",
  product_add_error: "התרחשה שגיאה בהוספת מוצר",
};

window.CART_STR = {
  product_add: "המוצר נוסף לסל שלכם",
  porduct_deleted: "המוצר נמחק לסל שלכם",
  product_add_error: "התרחשה שגיאה בהוספת מוצר",
};

window.STATUS_STR = {
  confirmed: "מאושר",
  on_hold: "בהמתנה",
  canceld: "בוטל",
  not_yet_confirmed: "טרם אושר",
  in_preparation: "בהכנה",
  ready_to_pickup: "מוכן לאיסוף",
};

window.COURIERS_STR = {
  courier_name: "שם שליח",
  status: "סטטוס",
  on_hold: "בהמתנה",
  canceld: "בוטל",
  not_yet_confirmed: "טרם אושר",
  no_selected_courier: "לא בחרתם שליח",
};

window.VALIDATION_ERROR_STR = {
  describe_your_problem: "תארו את הבעיה שלכם בכמה מילים",
  required_field: "שדה חובה",
  missing_field: "לא השלמתם את כל השדות !",
  missing_email: "חסר כתובת מייל",
  missing_password: "לא הכנסתם את סיסמתכם",
  words: "אותיות",
  phone_invalid: "מספר טלפון לא תקין",
  phone_empty: "לא הכנסתם מספר טלפון",
  first_name: "לא הכנסתם את השם שלכם",
  last_name: "לא הכנסתם שם משפחה",
  invalid_input: "הכנסתם ערך לא תקין",
  invalid_fullname_length: "שם מלא צריך להכיל אותיות בין ",
  email_invalid: "מייל לא תקין",
  password_not_equl: "ססימאות לא זהות",
  order_tel_invalid: "מספר טלפון להזמנות לא תקין",
  logo_requierd: "חובה להעלות לוגו לעסק",
  company_id: "מספר ח.פ / עוסק מורשה לא תקין",
  error_try_again: "שגיאה נסה שוב מאוחר יותר",
  invalid_file: "לא ניתן להעלות קובץ מסוג זה",
  rqeuired_logo: "חובה להעלות לוגו לעסק",
  google_link_invalid: "קישור Google לא תקין",
  instagram_url_invalid: "קישור Instagram לא תקין",
  telegram_number_invalid: "מספר טלגרם לא תקין",
  whatsapp_number_invalid: "מספר WhatsApp לא תקין",
  facebook_url_invalid: "כתובת Facebook לא תקינה",
  verification_code_not_send: "לא נשלח קוד אימות",
  invalid_verification_code: "קוד אימות שגוי",
  check_login_credential: "בדוק אמצעי כניסה",
  too_many_attempts: "יותר מידי נסיונות נסו בעוד כמה דקות",
  maximum_service: "ניתן לבחור מקסימום 5 שירותים",
  gps_not_enabel: "בדקו הגדרות המיקום (GPS)",
  gps_unavailable: "שירותי המיקום לא זמינים",
  email_password_send: "קישור לאיפוס סיסמה נשלח לכתובת המייל שלכם",
  phoneLoginError: "שירות התחברות דרך טלפון לא זמין כעת נסו שוב מאוחר יותר",
};

window.CATEGORIES_ERROR_STR = {
  cats_required: "חובה לבחור קטגוריה",
};

window.SORT_STR = {
  active: "פעיל",
  not_active: "לא פעיל",
  display_in_sale: "להציג במבצעים",
};

window.MAP_STR = {
  your_location: "המיקום שלכם",
  location_not_found: "מיקום לא נמצא",
  my_location: "המיקום שלי",
  geolocation_is_not_supported_by_your_browser: "מיקום גיאוגרפי אינו נתמך על ידי הדפדפן שלך",
  user_denied_the_request_for_geolocation: "אין הרשאות לגשת למיקום גיאוגרפי",
  location_information_is_unavailable: "פרטי המיקום אינם זמינים",
  error_try_again: "שגיאה נסה שוב מאוחר יותר",
  error_obtaining_location_please_try_again: "שגיאה בהשגת מיקום. בבקשה נסה שוב",
  please_enable_location_services_and_allow_this_website_to_access_your_location: "אנא הפעל שירותי מיקום ואפשרו לגשת למיקום שלך",
  geolocation_is_not_supported_by_your_browser_please_enable_it_in_your_browser_settings: "מיקום גיאוגרפי אינו נתמך על ידי הדפדפן שלך. אנא הפעל את זה בהגדרות הדפדפן שלך",
};

window.LOCATION_STR = {
  browser_not_supported: "המיקום אינו נתמך בדפדפן זה.",
  permission_denied: "הגישה למיקום נדחתה",
  location_unavailable: "שירותי המיקום לא זמינים כעת, נסה שוב מאוחר יותר",
  unknown_error: "שגיאה לא ידועה",
  default_card_message: "אירעה שגיאה בעת קבלת המיקום",
};

window.GPS = {
  unsupported_api: "‏ממשק Geolocation או Permissions לא נתמך",
  permission_not_granted: "לא ניתנה הרשאת מיקום",
  permission_check_error: "לא ניתן לבדוק הרשאות מיקום",
};
